import { ContactHeader, Contact, Footer } from '../../components';

const ContactPage = () => {
    return (
    <>
        <ContactHeader />
        <Contact />
        <Footer />
    </>
    );
}

export { ContactPage };